import { render } from "./TaskCounter.vue?vue&type=template&id=7d668913"
import script from "./TaskCounter.vue?vue&type=script&lang=js"
export * from "./TaskCounter.vue?vue&type=script&lang=js"
script.render = render

export default script